import {
    CreateConservationActionActivityFeedItemDescription
} from "./Types";
import {
    CreateProgramActivityFeedItemDescription
} from "./Types";
import {
    CreateProjectActivityFeedItemDescription
} from "./Types";
import {
    DeleteConservationActionActivityFeedItemDescription
} from "./Types";
import {
    DeleteProgramActivityFeedItemDescription
} from "./Types";
import {
    DeleteProjectActivityFeedItemDescription
} from "./Types";
import {
    SampleEventSyncActivityFeedItemDescription
} from "./Types";
import {
    UpdateConservationActionDetailsActivityFeedItemDescription
} from "./Types";
import {
    UpdateProgramDetailsActivityFeedItemDescription
} from "./Types";
import {
    UpdateProgramProjectedUpliftActivityFeedItemDescription
} from "./Types";
import {
    UpdateProjectNicknamesActivityFeedItemDescription
} from "./Types";
import {
    UpdateProjectDetailsActivityFeedItemDescription
} from "./Types";
import {
    UpdateProjectStakeholdersActivityFeedItemDescription
} from "./Types/UpdateProjectStakeholdersActivityFeedItemDescription";
import {
    UpdateProjectTaxLotsActivityFeedItemDescription
} from "./Types";
import {
    CreatePermitActivityFeedItemDescription
} from "./Types/CreatePermitActivityFeedItemDescription";
import {
    DeletePermitActivityFeedItemDescription
} from "./Types/DeletePermitActivityFeedItemDescription";
import {
    UpdatePermitDetailsActivityFeedItemDescription
} from "./Types/UpdatePermitDetailsActivityFeedItemDescription";
import {
    ExpiringPermitDetailsActivityFeedItemDescription
} from "./Types/ExpiringPermitDetailsActivityFeedItemDescription";
import {
    UpdateContactDetailsActivityFeedItemDescription
} from "./Types/UpdateContactDetailsActivityFeedItemDescription";
import {
    UpdateConservationActionModeledUpliftActivityFeedItemDescription
} from "./Types/UpdateConservationActionModeledUpliftActivityFeedItemDescription";
import {CreateSpeciesActivityFeedItemDescription} from "./Types/CreateSpeciesActivityFeedItemDescription";
import {service as ActivityTypeService} from '../../../Services/ActivityTypeService'
import {UpdateSpeciesActivityFeedItemDescription} from "./Types/UpdateSpeciesActivityFeedItemDescription";
import {SpeciesActivityTitle} from "./Types/SpeciesActivityTitle";
import {StreamBankLink} from "../StreamBankLink";
import React from "react";
import {DefaultActivityTitle} from "./Types/DefaultActivityTitle";
import {DenySpeciesActivityFeedItemDescription} from "./Types/DenySpeciesActivityFeedItemDescription";

export class ActivityFeedEventRenderFactory {
    static getContextForActivity(eventTypes, activity) {
        const titleRenderer = ActivityFeedEventRenderFactory.getTitleForActivity(eventTypes, activity);
        const descriptionRenderer = ActivityFeedEventRenderFactory.getDescriptionForActivity(eventTypes, activity);

        if(descriptionRenderer !== null) {
            return {
                title: titleRenderer,
                description: descriptionRenderer,
                valid: true
            };
        } else {
            return {
                description: null,
                valid: false
            };
        }
    }

    // returns a component or string description
    static getTitleForActivity(eventTypes, activity) {
        let eventType = ActivityFeedEventRenderFactory.getTypeForActivity(eventTypes, activity);

        switch (eventType?.code) {
            case "create_species":
                // fallthrough
            case "deny_species":
                // fallthrough
            case "delete_species":
                // fallthrough
            case "update_species":
                return SpeciesActivityTitle;
            default:
                return DefaultActivityTitle;
        }
    }

    // returns a component or string description
    static getDescriptionForActivity(eventTypes, activity) {
        let eventType = ActivityFeedEventRenderFactory.getTypeForActivity(eventTypes, activity);

        switch(eventType?.code) {
            case "create_conservation_action":
                return CreateConservationActionActivityFeedItemDescription;
            case "create_program":
                return CreateProgramActivityFeedItemDescription;
            case "create_project":
                return CreateProjectActivityFeedItemDescription;
            case "delete_conservation_action":
                return DeleteConservationActionActivityFeedItemDescription;
            case "delete_program":
                return DeleteProgramActivityFeedItemDescription;
            case "delete_project":
                return DeleteProjectActivityFeedItemDescription;
            case "sync_sample_event":
                return SampleEventSyncActivityFeedItemDescription;
            case "update_conservation_action_details":
                return UpdateConservationActionDetailsActivityFeedItemDescription;
            case "update_conservation_action_modeled_uplift":
                return UpdateConservationActionModeledUpliftActivityFeedItemDescription;
            case "update_contact_details":
                return UpdateContactDetailsActivityFeedItemDescription;
            case "update_program_details":
                return UpdateProgramDetailsActivityFeedItemDescription;
            case "update_program_projected_uplift":
                return UpdateProgramProjectedUpliftActivityFeedItemDescription;
            case "update_project_aliases":
                return UpdateProjectNicknamesActivityFeedItemDescription;
            case "update_project_details":
                return UpdateProjectDetailsActivityFeedItemDescription;
            case "update_project_stakeholders":
                return UpdateProjectStakeholdersActivityFeedItemDescription;
            case "update_project_taxlots":
                return UpdateProjectTaxLotsActivityFeedItemDescription;
            case "create_permit":
                return CreatePermitActivityFeedItemDescription;
            case "delete_permit":
                return DeletePermitActivityFeedItemDescription;
            case "update_permit":
                return UpdatePermitDetailsActivityFeedItemDescription;
            case "expiring_permit":
                return ExpiringPermitDetailsActivityFeedItemDescription;
            case "create_species":
                return CreateSpeciesActivityFeedItemDescription;
            case "update_species":
                return UpdateSpeciesActivityFeedItemDescription;
            case "deny_species":
                return DenySpeciesActivityFeedItemDescription;
            default:
                return null;
        }
    }

    static getTypeForActivity(eventTypes, activity) {
        if(eventTypes && eventTypes.length) {
            return eventTypes.find((x) => x.activityTypeId === activity.Activity.activityTypeId);
        }

        return null;
    }
}


